import styled from "styled-components";

export const Wrapper = styled.div<{ inBasket?: boolean }>`
    display: flex;
    flex-direction: column;

    padding: ${({ inBasket }) => (inBasket ? "var(--spacing-1)" : "var(--spacing-0)")};
    background-color: ${({ inBasket }) => (inBasket ? "var(--color-grey-1)" : "var(--color-primary-white)")};
`;
